import { render } from "./form-part-a-confirmation.html?vue&type=template&id=8af9e7f4&scoped=true&ts=true&external"
import script from "./form-part-a-confirmation.ts?vue&type=script&lang=ts&external"
export * from "./form-part-a-confirmation.ts?vue&type=script&lang=ts&external"

import "./form-part-a-confirmation.scss?vue&type=style&index=0&id=8af9e7f4&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8af9e7f4"]])

export default __exports__